module.exports = __webpack_public_path__ + "static/media/4.question.f888db72.mp4";